import { customerActionTypes } from '@Actions/customerActions';

const CustomerReducer = (state = {}, action) => {
  switch (action.type) {
  case customerActionTypes.CREATE_CUSTOMER.LOADING: {
    const { createCustomerLoading } = action;
    return {
      ...state,
      createCustomerLoading,
    };
  }
  case customerActionTypes.CREATE_CUSTOMER.SUCCESS: {
    const { createdCustomer } = action;
    return {
      ...state,
      createdCustomer,
    };
  }
  case customerActionTypes.GET_CUSTOMERS.LOADING: {
    const { getCustomersLoading } = action;
    return {
      ...state,
      getCustomersLoading,
    };
  }
  case customerActionTypes.GET_CUSTOMERS.SUCCESS: {
    const { customers } = action;
    return {
      ...state,
      customers,
    };
  }
  case customerActionTypes.GET_CUSTOMER_BY_ID.LOADING: {
    const { getCustomerByIdLoading } = action;
    return {
      ...state,
      getCustomerByIdLoading,
    };
  }
  case customerActionTypes.GET_CUSTOMER_BY_ID.SUCCESS: {
    const { selectedCustomer } = action;
    return {
      ...state,
      selectedCustomer,
    };
  }
  case customerActionTypes.UPDATE_CUSTOMER.LOADING: {
    const { updateCustomerLoading } = action;
    return {
      ...state,
      updateCustomerLoading,
    };
  }
  case customerActionTypes.UPDATE_CUSTOMER.SUCCESS: {
    const { updatedCustomer } = action;
    return {
      ...state,
      updatedCustomer,
    };
  }
  case customerActionTypes.GET_ORG_CUSTOMERS.LOADING: {
    const { getOrgCustomersLoading } = action;
    return {
      ...state,
      getOrgCustomersLoading,
    };
  }
  case customerActionTypes.GET_ORG_CUSTOMERS.SUCCESS: {
    const { orgCustomers } = action;
    return {
      ...state,
      orgCustomers,
    };
  }
  case customerActionTypes.GET_BULK_UPLOAD_CUSTOMER_META_DATA.LOADING: {
    const { getBulkUploadCustomerMetadataLoading } = action;
    return {
      ...state,
      getBulkUploadCustomerMetadataLoading,
    };
  }
  case customerActionTypes.GET_BULK_UPLOAD_CUSTOMER_META_DATA.SUCCESS: {
    const { bulkUploadCustomerMetadata } = action;
    return {
      ...state,
      bulkUploadCustomerMetadata,
    };
  }
  case customerActionTypes.BULK_UPLOAD_CUSTOMER.LOADING: {
    const { bulkUploadCustomersLoading } = action;
    return {
      ...state,
      bulkUploadCustomersLoading,
    };
  }
  case customerActionTypes.BULK_UPLOAD_CUSTOMER.SUCCESS: {
    const { bulkUploadResponse } = action;
    return {
      ...state,
      bulkUploadResponse,
    };
  }
  case customerActionTypes.BULK_UPLOAD_CUSTOMER.ERROR: {
    const { bulkUploadError } = action;
    return {
      ...state,
      bulkUploadError,
    };
  }
  case customerActionTypes.BULK_UPDATE_CUSTOMER.LOADING: {
    const { bulkUpdateCustomersLoading } = action;
    return {
      ...state,
      bulkUpdateCustomersLoading,
    };
  }
  case customerActionTypes.BULK_UPDATE_CUSTOMER.SUCCESS: {
    const { bulkUpdateResponse } = action;
    return {
      ...state,
      bulkUpdateResponse,
    };
  }
  case customerActionTypes.BULK_UPDATE_CUSTOMER.ERROR: {
    const { bulkUpdateError } = action;
    return {
      ...state,
      bulkUpdateError,
    };
  }
  case customerActionTypes.GET_TALLY_CUSTOMERS.LOADING: {
    const { getTallyCustomersLoading } = action;
    return {
      ...state,
      getTallyCustomersLoading,
    };
  }
  case customerActionTypes.GET_TALLY_CUSTOMERS.SUCCESS: {
    const { tallyCustomers } = action;
    return {
      ...state,
      tallyCustomers,
    };
  }
  default: {
    return state;
  }
  }
};

export default CustomerReducer;
